/* Velocure — interactions. Без библиотек. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* защита от двойной инициализации: vc.js подключён и в хедере, и в секциях */
  function once(el, key) {
    var k = 'vcInit' + key;
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }

  /* ---------- 0. TOPBAR: уезжает при скролле вниз, возвращается при скролле вверх ---------- */
  function initTopbar(bar) {
    if (!once(bar, 'Topbar')) return;
    var last = window.scrollY, ticking = false;
    function onScroll() {
      var y = window.scrollY;
      var down = y > last && y > 160;
      bar.setAttribute('data-hidden', down ? 'true' : 'false');
      last = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
  }

  /* ---------- 0b. мобильное меню ---------- */
  function initBurger(btn) {
    if (!once(btn, 'Burger')) return;
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      nav.hidden = open;
    });
  }

  /* ---------- 1. HERO ---------- */
  function initHero(root) {
    if (!once(root, 'Hero')) return;
    var slides = [].slice.call(root.querySelectorAll('[data-vc-slide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-vc-dot]'));
    var meta = root.querySelector('[data-vc-hero-meta]');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var delay = parseInt(root.getAttribute('data-vc-interval') || '6500', 10);

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.setAttribute('data-active', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (meta) {
        var src = slides[i];
        meta.querySelectorAll('[data-vc-meta-field]').forEach(function (el) {
          var v = src.getAttribute('data-' + el.getAttribute('data-vc-meta-field'));
          if (v) el.textContent = v;
        });
      }
    }
    function play() { stop(); if (!reduce) timer = setInterval(function () { show(i + 1); }, delay); }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); play(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });

    /* свайп на телефоне */
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) show(i + (dx < 0 ? 1 : -1));
      x0 = null; play();
    }, { passive: true });

    show(0); play();
  }

  /* ---------- 2. FEATURES: активная карточка ---------- */
  function initFeatures(root) {
    if (!once(root, 'Features')) return;
    var cards = [].slice.call(root.querySelectorAll('[data-vc-feat]'));
    if (!cards.length) return;
    function setActive(card) {
      cards.forEach(function (c) { c.setAttribute('data-active', c === card ? 'true' : 'false'); });
    }
    cards.forEach(function (c) {
      c.addEventListener('mouseenter', function () { setActive(c); });
      c.addEventListener('focus', function () { setActive(c); });
    });
    setActive(cards[0]);
  }

  /* ---------- 3. TESTIMONIALS ---------- */
  function initTst(root) {
    if (!once(root, 'Tst')) return;
    var track = root.querySelector('[data-vc-track]');
    var items = [].slice.call(root.querySelectorAll('[data-vc-tst-item]'));
    var prev = root.querySelector('[data-vc-prev]');
    var next = root.querySelector('[data-vc-next]');
    if (!track || !items.length) return;
    var i = 0;

    function step() {
      var w = items[0].getBoundingClientRect().width;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || 0) || 0;
      return { w: w, gap: gap };
    }
    function maxIndex() {
      var m = step();
      var vp = track.parentElement.getBoundingClientRect().width;
      var per = Math.max(1, Math.round((vp + m.gap) / (m.w + m.gap)));
      return Math.max(0, items.length - per);
    }
    function render() {
      var m = step();
      var max = maxIndex();
      if (i > max) i = max;
      if (i < 0) i = 0;
      track.style.transform = 'translate3d(-' + (i * (m.w + m.gap)) + 'px,0,0)';
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i >= max;
    }
    if (prev) prev.addEventListener('click', function () { i -= 1; render(); });
    if (next) next.addEventListener('click', function () { i += 1; render(); });
    window.addEventListener('resize', render);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { i += (dx < 0 ? 1 : -1); render(); }
      x0 = null;
    }, { passive: true });
    render();
  }

  /* ---------- 4. HOTSPOTS ---------- */
  function initHotspots(root) {
    if (!once(root, 'Hotspots')) return;
    var tabs = [].slice.call(root.querySelectorAll('[data-vc-hs-tab]'));
    var scenes = [].slice.call(root.querySelectorAll('[data-vc-hs-scene]'));
    var dots = [].slice.call(root.querySelectorAll('[data-vc-hs-dot]'));

    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, n) { x.setAttribute('aria-selected', n === k ? 'true' : 'false'); });
        scenes.forEach(function (s, n) { s.setAttribute('data-active', n === k ? 'true' : 'false'); });
        closeAll();
      });
    });

    function closeAll(except) {
      dots.forEach(function (d) {
        if (d === except) return;
        d.setAttribute('aria-expanded', 'false');
        var c = document.getElementById(d.getAttribute('aria-controls'));
        if (c) c.setAttribute('data-open', 'false');
      });
    }

    dots.forEach(function (d) {
      var card = document.getElementById(d.getAttribute('aria-controls'));
      if (!card) return;
      function place() {
        var x = parseFloat(d.getAttribute('data-x'));
        var y = parseFloat(d.getAttribute('data-y'));
        var narrow = window.innerWidth < 700;
        if (narrow) {
          card.style.left = '50%';
          card.style.right = 'auto';
          card.style.transform = 'translateX(-50%)';
          card.style.top = 'auto';
          card.style.bottom = '14px';
          return;
        }
        card.style.transform = '';
        card.style.bottom = 'auto';
        var right = x > 55;
        card.style.left = right ? 'auto' : 'calc(' + x + '% + 26px)';
        card.style.right = right ? 'calc(' + (100 - x) + '% + 26px)' : 'auto';
        card.style.top = 'min(calc(' + y + '% - 12px), calc(100% - 200px))';
      }
      function toggle() {
        var open = d.getAttribute('aria-expanded') === 'true';
        closeAll(d);
        place();
        d.setAttribute('aria-expanded', open ? 'false' : 'true');
        card.setAttribute('data-open', open ? 'false' : 'true');
      }
      d.addEventListener('click', toggle);
      if (window.matchMedia('(hover: hover)').matches) {
        d.addEventListener('mouseenter', function () {
          closeAll(d); place();
          d.setAttribute('aria-expanded', 'true'); card.setAttribute('data-open', 'true');
        });
      }
      card.addEventListener('mouseleave', function () { closeAll(); });
    });
    root.addEventListener('mouseleave', function () { closeAll(); });
  }

  /* ---------- 5. FAQ: каждый вопрос независим ---------- */
  function initFaq(root) {
    if (!once(root, 'Faq')) return;
    var items = [].slice.call(root.querySelectorAll('[data-vc-faq-item]'));
    items.forEach(function (item) {
      var btn = item.querySelector('[data-vc-faq-q]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.getAttribute('data-open') === 'true';
        item.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        var icon = btn.querySelector('.vc-faq__icon');
        if (icon) icon.textContent = open ? '+' : '–';
      });
    });
  }

  /* ---------- 5b. галерея товара ---------- */
  function initGallery(root) {
    if (!once(root, 'Gallery')) return;
    var main = root.querySelector('[data-vc-gallery-main]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-vc-thumb]'));
    if (!main || thumbs.length < 2) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        var alt = t.getAttribute('data-alt') || '';
        if (src) { main.src = src; main.alt = alt; main.removeAttribute('srcset'); }
        thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      });
    });
  }

  /* ---------- 5c. количество ---------- */
  function initQty(root) {
    if (!once(root, 'Qty')) return;
    var input = root.querySelector('input');
    var minus = root.querySelector('[data-vc-qty-minus]');
    var plus = root.querySelector('[data-vc-qty-plus]');
    if (!input) return;
    function set(v) { input.value = Math.max(1, Math.min(99, v)); }
    if (minus) minus.addEventListener('click', function (e) { e.preventDefault(); set(parseInt(input.value || '1', 10) - 1); });
    if (plus) plus.addEventListener('click', function (e) { e.preventDefault(); set(parseInt(input.value || '1', 10) + 1); });
  }


  /* ---------- 7. CART DRAWER ---------- */
  var cartDrawer = null;

  function initDrawer(root) {
    if (!once(root, 'Drawer')) return;
    cartDrawer = root;
    var content = root.querySelector('[data-vc-drawer-content]');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      root.setAttribute('data-open', 'true');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('vc-lock');
      var c = root.querySelector('.vc-drawer__close');
      if (c) c.focus();
    }
    function close() {
      root.setAttribute('data-open', 'false');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('vc-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function busy(on) {
      content.style.opacity = on ? '.45' : '';
      content.style.pointerEvents = on ? 'none' : '';
    }
    function syncCount() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('[data-vc-cart-count]').forEach(function (el) { el.textContent = '(' + c.item_count + ')'; });
        }).catch(function () {});
    }
    function refresh() {
      return fetch('/cart?view=drawer', { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) { content.innerHTML = html; syncCount(); });
    }
    function change(line, qty) {
      busy(true);
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
      }).then(function () { return refresh(); })
        .then(function () { busy(false); })
        .catch(function () { busy(false); window.location.href = '/cart'; });
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-vc-cart-close]')) { e.preventDefault(); close(); return; }
      var line = e.target.closest('[data-vc-line]');
      if (line) { e.preventDefault(); change(line.getAttribute('data-vc-line'), line.getAttribute('data-vc-to')); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.getAttribute('data-open') === 'true') close();
    });

    root.vcOpen = open; root.vcClose = close; root.vcRefresh = refresh;
  }

  function initCartOpener(a) {
    if (!once(a, 'CartOpen')) return;
    a.addEventListener('click', function (e) {
      if (!cartDrawer) return;
      e.preventDefault();
      cartDrawer.vcOpen();
    });
  }

  function initAtc(form) {
    if (!once(form, 'Atc')) return;
    form.addEventListener('submit', function (e) {
      var sub = e.submitter;
      if (sub && sub.name === 'checkout') return;   /* Buy it now — обычная отправка */
      if (!cartDrawer) return;
      e.preventDefault();
      var btn = form.querySelector('[data-vc-atc-btn]');
      var label = btn ? btn.textContent.trim() : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return cartDrawer.vcRefresh(); })
        .then(function () { cartDrawer.vcOpen(); if (btn) { btn.disabled = false; btn.textContent = label; } })
        .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } form.submit(); });
    });
  }

  /* ---------- 8. ВАРИАНТЫ ТОВАРА ---------- */
  function initVariants(root) {
    if (!once(root, 'Variants')) return;
    var data = root.querySelector('[data-vc-variants]');
    var radios = [].slice.call(root.querySelectorAll('[data-vc-option]'));
    if (!data || !radios.length) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-vc-variant-id]');
    var priceEl = root.querySelector('[data-vc-price]');
    var wasEl = root.querySelector('[data-vc-was]');
    var saveEl = root.querySelector('[data-vc-save]');
    var stockEl = root.querySelector('[data-vc-stock]');
    var btn = root.querySelector('[data-vc-atc-btn]');
    var main = root.querySelector('[data-vc-gallery-main]');
    if (btn) btn.dataset.label = btn.textContent.trim();

    function apply() {
      var sel = [];
      radios.forEach(function (r) { if (r.checked) sel[parseInt(r.getAttribute('data-vc-option'), 10) - 1] = r.value; });
      var v = variants.filter(function (x) {
        return x.options.every(function (o, i) { return o === sel[i]; });
      })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (wasEl) { wasEl.textContent = v.onSale ? v.compare : ''; wasEl.hidden = !v.onSale; }
      if (saveEl) { saveEl.textContent = 'Save ' + v.save; saveEl.hidden = !v.onSale; }
      if (stockEl) {
        stockEl.textContent = v.available ? 'In stock' : 'Sold out';
        stockEl.classList.toggle('vc-badge--out', !v.available);
      }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.label : 'Sold out'; }
      if (v.img && main) { main.src = v.img; main.removeAttribute('srcset'); }
      try { window.history.replaceState({}, '', '?variant=' + v.id); } catch (e) {}
    }
    radios.forEach(function (r) { r.addEventListener('change', apply); });
  }

  function initCompanionAdd(btn) {
    if (!once(btn, 'CompanionAdd')) return;
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var label = btn.dataset.label || btn.textContent.trim();
      btn.dataset.label = label;
      btn.disabled = true;
      btn.textContent = '\u00b7\u00b7\u00b7';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () {
          btn.textContent = '\u2713';
          if (cartDrawer) return cartDrawer.vcRefresh().then(function () { cartDrawer.vcOpen(); });
        })
        .then(function () {
          setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1200);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = label;
          window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
        });
    });
  }

  function initCopy(btn) {
    if (!once(btn, 'Copy')) return;
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url') || window.location.href;
      if (navigator.clipboard) navigator.clipboard.writeText(url).catch(function () {});
      btn.style.opacity = '1';
    });
  }

  /* ---------- 6. reveal ---------- */
  function initReveal() {
    var els = [].slice.call(document.querySelectorAll('[data-vc-reveal]'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.setAttribute('data-revealed', 'true'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.setAttribute('data-revealed', 'true'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  function boot() {
    document.querySelectorAll('[data-vc-topbar]').forEach(initTopbar);
    document.querySelectorAll('[data-vc-burger]').forEach(initBurger);
    document.querySelectorAll('[data-vc-hero]').forEach(initHero);
    document.querySelectorAll('[data-vc-features]').forEach(initFeatures);
    document.querySelectorAll('[data-vc-tst]').forEach(initTst);
    document.querySelectorAll('[data-vc-hs]').forEach(initHotspots);
    document.querySelectorAll('[data-vc-faq]').forEach(initFaq);
    document.querySelectorAll('[data-vc-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-vc-qty]').forEach(initQty);
    document.querySelectorAll('[data-vc-drawer]').forEach(initDrawer);
    document.querySelectorAll('[data-vc-cart-open]').forEach(initCartOpener);
    document.querySelectorAll('form[action$="/cart/add"]').forEach(initAtc);
    document.querySelectorAll('[data-vc-pdp]').forEach(initVariants);
    document.querySelectorAll('[data-vc-copy]').forEach(initCopy);
    document.querySelectorAll('[data-vc-companion-add]').forEach(initCompanionAdd);
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
